import { ArrowForward } from '@mui/icons-material';
import styled from '@emotion/styled';
import { uiTheme as t } from './theme';

interface CtaProps {
  /** Texto de la llamada a la acción (p. ej. "Administrar"). */
  label: string;
  /** Color del texto y la flecha. */
  color?: string;
}

const Row = styled.div<{ color: string }>(({ color }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  color,
  '& .MuiSvgIcon-root': { fontSize: 20 },
}));

const Label = styled.span({
  fontFamily: t.font,
  fontSize: 13.5,
  fontWeight: 600,
});

/**
 * Primitivo: fila "etiqueta + flecha" que cierra una tarjeta accionable.
 */
const Cta = ({ label, color = t.color.primary }: CtaProps) => (
  <Row color={color}>
    <Label>{label}</Label>
    <ArrowForward />
  </Row>
);

export default Cta;
